import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { persistStore } from 'redux-persist';
import reactotron from '../utils/reactotron';
import { apiBaseMiddleware } from './api/services/rtkQuery/apiBaseQuery';
import { pReducer } from './rootReducer';
import { setStore } from './storeRef';
export var store = configureStore({
  reducer: pReducer,
  devTools: true,
  middleware: function middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }).concat(apiBaseMiddleware);
  },
  enhancers: function enhancers(getDefaultEnhancers) {
    var defaults = getDefaultEnhancers();
    return reactotron ? defaults.concat(reactotron.createEnhancer()) : defaults;
  }
});

// Expose the store to the axios service layer without a direct import there
// (breaks the store -> rootReducer -> apiBaseQuery -> axios -> store require cycle).
setStore(store);
setupListeners(store.dispatch);
export var persistor = persistStore(store);
export default store;